import usePageMeta from "@/hooks/usePageMeta";
import HeroSection from "@/components/home/HeroSection";
import BenefitCards from "@/components/home/BenefitCards";
import StartSection from "@/components/home/StartSection";
import AudienceCards from "@/components/home/AudienceCards";
import { AanpakSection, TrustSection, CTASection } from "@/components/home/HomeSections";

const ORG_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "LevelLeven",
  url: "https://levelleven.nl/",
  logo: "https://levelleven.nl/brand/levelleven-logo.png",
  email: "info@levelleven.nl",
  slogan: "In beweging · In ontwikkeling",
  description: "Twaalf weken persoonlijke ontwikkeling, inzicht en een passende volgende stap voor mensen die langdurig stilstaan.",
};

export default function Home() {
  usePageMeta({
    title: "LevelLeven — Twaalf weken voor een nieuw begin",
    description:
      "LevelLeven START: twaalf weken persoonlijke ontwikkeling, inzicht en een passende volgende stap. Voor inwoners die langdurig stilstaan en voor gemeenten die een pilot willen verkennen.",
  });

  return (
    <div className="bg-ll-cream" data-testid="home-page">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(ORG_LD) }} />
      <HeroSection />
      <BenefitCards />
      <StartSection />
      <AudienceCards />
      <AanpakSection />
      <TrustSection />
      <CTASection />
    </div>
  );
}
